import React from "react";
import './globalsearch.css'
import { useGlobalPagination } from "./Pagination/paginationStore";

function GlobalSearch() {
  const { search, setSearch } = useGlobalPagination();

  return (
    <input
      type="text"
      className="input1"
      placeholder="&#61442; Search"
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
      }}
      style={{ fontfamily: "Arial, FontAwesome", marginRight: "6px" }}
    />
  );
}

export default GlobalSearch;
